"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var fastest_validator_1 = __importDefault(require("fastest-validator"));
var arrayReducedEqualsValidationRule_1 = __importDefault(require("./arrayReducedEqualsValidationRule"));
var dateCompareValidationRule_1 = __importDefault(require("./dateCompareValidationRule"));
var emailValidationRule_1 = __importDefault(require("./emailValidationRule"));
var phoneNumberValidationRule_1 = __importDefault(require("./phoneNumberValidationRule"));
var validationMessages_1 = __importDefault(require("./validationMessages"));
function createValidator(t, options) {
    var _a = options || {}, aliases = _a.aliases, messages = _a.messages, _b = _a.rules, ruleOptions = _b === void 0 ? [] : _b;
    /**
     * Generate error source code.
     * @param {Object} opts
     * @param {String} opts.type
     * @param {String} opts.field
     * @param {any} opts.expected
     * @param {any} opts.actual
     * @param {Object} opts.messages
     */
    fastest_validator_1.default.prototype.makeError = function makeErrorTranslated(_a) {
        var type = _a.type, field = _a.field, expected = _a.expected, actual = _a.actual, messages = _a.messages;
        var o = {
            message: !messages[type]
                ? 'undefined'
                : Array.isArray(messages[type])
                    ? JSON.stringify(messages[type])
                    : "\"" + messages[type] + "\"",
            type: "\"" + type + "\"",
        };
        if (field)
            o.field = "\"" + field + "\"";
        else
            o.field = 'field';
        if (expected != null)
            o.expected = expected;
        if (actual != null)
            o.actual = actual;
        var s = Object.keys(o)
            .map(function (key) { return key + ": " + o[key]; })
            .join(', ');
        return "errors.push({ " + s + " });";
    };
    /**
     * Compile a schema
     *
     * @param {Object} schema
     * @throws {Error} Invalid schema
     * @returns {Function}
     */
    fastest_validator_1.default.prototype.compile = function compileTranslated(schema) {
        if (schema === null || typeof schema !== 'object') {
            throw new Error('Invalid schema.');
        }
        // eslint-disable-next-line @typescript-eslint/no-this-alias
        var self = this;
        var context = {
            customs: {},
            fn: [],
            index: 0,
            rules: [],
            translator: t,
        };
        // @ts-ignore
        this.cache.clear();
        // @ts-ignore
        if (schema.$$root !== true) {
            if (Array.isArray(schema)) {
                // @ts-ignore
                var rule_1 = this.getRuleFromSchema(schema);
                // @ts-ignore
                schema = rule_1.schema;
            }
            else {
                var prevSchema = Object.assign({}, schema);
                schema = {
                    // @ts-ignore
                    properties: prevSchema,
                    strict: prevSchema.$$strict,
                    type: 'object',
                };
                delete prevSchema.$$strict;
            }
        }
        var sourceCode = ['var errors = [];', 'var field;', 'var parent = null;'];
        // @ts-ignore
        var rule = this.getRuleFromSchema(schema);
        sourceCode.push(
        // @ts-ignore
        this.compileRule(rule, context, null, 'context.fn[%%INDEX%%](value, field, null, errors, context);', 'value'));
        sourceCode.push('if (errors.length) {');
        sourceCode.push("\n\t\t\treturn errors.map(err => {\n\t\t\t\tif (err.message) {\n          if (typeof err.message === 'string') {\n            err.message = context.translator(\n              err.message,\n              {\n                field: err.field || '',\n                expected: err.expected != null ? err.expected : \"\",\n                actual: err.actual != null ? err.actual : \"\"\n              },\n            );\n          } else if (Array.isArray(err.message)) {\n            err.message = err.message[1]\n\t\t\t\t\t\t  .replace(/\\{field\\}/g, err.field || \"\")\n\t\t\t\t\t\t  .replace(/\\{expected\\}/g, err.expected != null ? err.expected : \"\")\n\t\t\t\t\t\t  .replace(/\\{actual\\}/g, err.actual != null ? err.actual : \"\");\n          } else {\n            err.message = \"ERROR MESSAGE NOT DEFINED OR NOT SUPPORTED!!!\";\n          }\n        }\n\n\t\t\t\treturn err;\n\t\t\t});\n\t\t");
        sourceCode.push('}');
        sourceCode.push('return true;');
        var src = sourceCode.join('\n');
        var checkFn = new Function('value', 'context', src);
        // !! Only form future merging
        // /* istanbul ignore next */
        // // @ts-ignore
        // if (this.opts.debug) {
        //   // @ts-ignore
        //   let formatter = function (code) {
        //     return code;
        //   };
        //   if (typeof window === 'undefined')
        //     // eslint-disable-line no-undef
        //     formatter = require('./helpers/prettier');
        //   // @ts-ignore
        //   context.fn.forEach((fn, i) => console.log(formatter(`// Context.fn[${i}]\n` + fn.toString()))); // eslint-disable-line no-console
        //   console.log(formatter('// Main check function\n' + checkFn.toString())); // eslint-disable-line no-console
        // }
        // @ts-ignore
        this.cache.clear();
        return function (data) {
            // @ts-ignore
            context.data = data;
            return checkFn.call(self, data, context);
        };
    };
    var _c = __read(ruleOptions.reduce(function (res, rule) {
        var _a, _b;
        var _c = __read(rule, 3), ruleKey = _c[0], ruleValidator = _c[1], ruleMessage = _c[2];
        var msgs = !ruleMessage
            ? undefined
            : typeof ruleMessage === 'object' && !Array.isArray(ruleMessage)
                ? ruleMessage
                : (_a = {}, _a[ruleKey] = ruleMessage, _a);
        return [__assign(__assign({}, res[0]), (_b = {}, _b[ruleKey] = ruleValidator, _b)), msgs ? __assign(__assign({}, res[1]), msgs) : res[1]];
    }, [{}, {}]), 2), customRules = _c[0], rulesMessages = _c[1];
    var validator = new fastest_validator_1.default({
        aliases: aliases,
        customRules: customRules,
        messages: __assign(__assign(__assign({}, validationMessages_1.default), messages), rulesMessages),
        useNewCustomCheckerFunction: true,
    });
    validator.add('phoneNumber', phoneNumberValidationRule_1.default);
    validator.add('arrayReducedEquals', arrayReducedEqualsValidationRule_1.default);
    validator.add('dateCompare', dateCompareValidationRule_1.default);
    // email validation has bug... fix it
    validator.add('email', emailValidationRule_1.default);
    return validator;
}
exports.default = createValidator;
//# sourceMappingURL=createValidator.js.map